import {
  CLEAR_EAR_DATA_SUCCESS,
  CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  FETCH_ASSETS_BY_EAI_SUCCESS,
  FETCH_EAI_BY_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS,
  SAVE_EMPLOYEE_ASSET_RECEIPT_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetsList:{},
  eaiList:[],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_EMPLOYEE_ASSET_RECEIPT_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_EAI_BY_EMPLOYEE_SUCCESS: {
      return {
        ...state,
        eaiList: action.data,
      }
    }

    case FETCH_ASSETS_BY_EAI_SUCCESS: {
      return {
        ...state,
        assetsList: action.data,
      }
    }

    case CLEAR_EAR_DATA_SUCCESS: {
      return {
        ...state,
        assetsList: [],
        edit:{},
        eaiList: [],
      }
    }
    default:
      return state;
  }
}
